module.exports = __webpack_public_path__ + "img/04.ba90ff25.png";